<template lang="pug">
 .dropdown(v-on-away="away")
  .dropdown(:class="{ 'is-active': activeDropdown, 'selected': isSelected, 'disabled': disabled }")
    .dropdown-trigger
      button.button(@click="toggleBtn")
        span {{ selectedItem.name || labelText }}
    .dropdown-menu(role="menu")
      .dropdown-content(v-if="items && !custom")
        a.dropdown-item(
          v-for="item in items"
          @click="selectItem(item.id)") {{ item.name}}
      .dropdown-content(v-else @click="toggleBtn")
        slot
</template>
<script>

import { gettext } from '@/services/TranslateHandler'
import { mapGetters } from 'vuex'
import { directive as onAway } from 'vue-clickaway'

const _ = require('lodash')

export default {
  name: 'DropDown',
  directives: {
    onAway
  },
  data () {
    return {
      activeDropdown: false,
      isSelected: false,
      selectedItem: {}
    }
  },
  props: {
    labelText: {
      default: gettext('Please select')
    },
    items: {
      default: () => []
    },
    all: {
      default: () => []
    },
    value: {
      default: () => {
        return []
      }
    },
    custom: {
      default: false
    },
    selected: {
      default: () => {
        return {}
      }
    },
    disabled: {
      default: false
    }
  },
  methods: {
    toggleBtn () {
      this.activeDropdown = !this.activeDropdown
    },
    selectItem (id) {
      let i = _.find(this.all, {'id': parseInt(id)})
      if (i) {
        this.$emit('input', id)
        this.activeDropdown = false
        this.selectedItem = i
      }
      this.isSelected = true
    },
    away () {
      this.activeDropdown = false
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ])
  },
  watch: {
    value: function (val) {
      if (val) this.selectItem(val)
    },
    selected (val) {
      if (val) this.selectedItem = val
    }
  },
  created () {
    if (this.value) this.selectItem(this.value)
    if (this.selected) this.selectedItem = this.selected
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dropdown-simple/index.vue